import { InjectionToken } from '@angular/core';

/**
 * Registration of a slice that opts into generic IndexedDB persistence. `persistSelector`
 * projects the slice to its serializable, store-safe shape (the exact value written on
 * `persistSlice`). The concurrency-store entry key is derived from `featureKey` as
 * `` `${featureKey}Slice` ``.
 */
export interface PersistedSlice {
    featureKey: string;
    persistSelector: (state: object) => unknown;
}

/**
 * Multi-provider token: each persisted slice's store module contributes one {@link
 * PersistedSlice}. `PersistenceEffects` collects them into a registry so a slice can be
 * persisted/rehydrated purely by feature key, without persistence depending on the slices.
 */
export const PERSISTED_SLICES = new InjectionToken<PersistedSlice[]>('PERSISTED_SLICES');
